import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=076ea547"
import script from "./Teaser.vue?vue&type=script&lang=ts"
export * from "./Teaser.vue?vue&type=script&lang=ts"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=076ea547&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports